
import { createSlice } from "@reduxjs/toolkit";

let initialCurrentServiceRequestFilterJourney = {}
const currentServiceRequestFilterJourneySlice = createSlice({
    name: 'currentServiceRequestFilterJourney',
    initialState: initialCurrentServiceRequestFilterJourney,
    reducers: {
        setCurrentServiceRequestFilterJourney: (state, action) => {
            return {
                ...action.payload
            }
        },
        resetCurrentServiceRequestFilterJourney: () => {
            return initialCurrentServiceRequestFilterJourney
        }
    },
});

export const { setCurrentServiceRequestFilterJourney, resetCurrentServiceRequestFilterJourney } = currentServiceRequestFilterJourneySlice.actions;
export default currentServiceRequestFilterJourneySlice.reducer;